var map = {
	"./Frame1.png": 6672,
	"./Frame2.png": 491,
	"./Frame3.png": 9986,
	"./Frame4.png": 1709,
	"./Frame5.png": 580,
	"./RN69-1.png": 6389,
	"./RN69-2.png": 7614,
	"./RN69-4.png": 7992,
	"./RN69-5.png": 705,
	"./RN69-6.png": 1722,
	"./RN69-7.png": 2483,
	"./RN69-8.png": 7188,
	"./RN69.png": 7267,
	"./banks.png": 363,
	"./cn-flag.png": 1408,
	"./en-flag.png": 586,
	"./gameimage/amb.png": 6746,
	"./gameimage/dragon1.png": 2900,
	"./gameimage/dragon2.png": 1807,
	"./gameimage/dragon3.png": 2790,
	"./gameimage/evol.png": 7024,
	"./gameimage/gclub.png": 5629,
	"./gameimage/gioco.png": 2163,
	"./gameimage/jili.png": 4666,
	"./gameimage/joker.png": 9015,
	"./gameimage/king.png": 3249,
	"./gameimage/micro.png": 9962,
	"./gameimage/pg.png": 2387,
	"./gameimage/play.png": 258,
	"./gameimage/prag.png": 4494,
	"./gameimage/prag1.png": 1573,
	"./gameimage/sa-gaming.png": 3200,
	"./gameimage/sbobet1.png": 9078,
	"./gameimage/sexy.png": 8365,
	"./gameimage/spade.png": 9941,
	"./gameimage/ufabet1.png": 634,
	"./gameimage/wm.png": 752,
	"./gameslogo/cq9.png": 4754,
	"./gameslogo/ebet.png": 6169,
	"./gameslogo/evoplay.png": 6393,
	"./gameslogo/jili.png": 9,
	"./gameslogo/joker.png": 7134,
	"./gameslogo/playstar.png": 8965,
	"./gameslogo/popk.png": 3583,
	"./icons/ball.png": 7606,
	"./icons/casino-chip.png": 7557,
	"./icons/fish.png": 8819,
	"./icons/home.png": 4584,
	"./icons/lotto.png": 143,
	"./icons/nav-menu-login.svg": 3346,
	"./icons/nav-menu-promotion.svg": 378,
	"./icons/nav-menu-register.svg": 7212,
	"./icons/nav-menu-support.svg": 4452,
	"./icons/slot-machine.png": 7233,
	"./icons/หน้าแรก.png": 2715,
	"./khm-flag.png": 6533,
	"./logo.png": 3153
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;